export interface StructuredHttpError {
  readonly status: number;
  readonly error?: unknown;
}

export function isExplicitSessionInvalidation(
  response: StructuredHttpError,
  explicitCodes: ReadonlySet<string>,
): boolean {
  if (response.status !== 401) return false;

  const code = structuredErrorCode(response.error);
  return code !== null && explicitCodes.has(code);
}

function structuredErrorCode(error: unknown): string | null {
  if (!isRecord(error)) return null;
  const envelopeError = error['error'];
  if (!isRecord(envelopeError)) return null;
  const code = envelopeError['code'];
  return typeof code === 'string' && code.length > 0 ? code : null;
}

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}
